import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';

export interface LeadAttachment {
    id: string;
    leadId: string;
    fileName: string;
    contentType: string;
    sizeBytes: number;
    uploadedByName?: string | null;
    createdAt: string;
}

/// Mesmo limite do servidor, conferido aqui para recusar antes de subir 10 MB à toa.
export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024;

export class LeadAttachmentService extends BaseService {
    protected get resourceName(): string {
        return 'crm';
    }

    public async list(leadId: string): Promise<AxiosResponse<{ data: LeadAttachment[] }>> {
        return await this.get(`leads/${leadId}/attachments`);
    }

    public async upload(leadId: string, file: File): Promise<AxiosResponse<{ data: LeadAttachment }>> {
        const form = new FormData();
        form.append('file', file);

        return await this.post(form, `leads/${leadId}/attachments`);
    }

    public async download(id: string): Promise<AxiosResponse<Blob>> {
        return await this.getFile(`attachments/${id}/download`);
    }

    public async remove(id: string): Promise<AxiosResponse<void>> {
        return await this.delete(`attachments/${id}`);
    }
}
